import { defineMessages } from '../../i18n/messages';

export const PlanNameMessages = defineMessages({
    FREE: {
        id: 'plan.name.free',
        text: 'Free',
        description: 'Display name for the free/trial plan tier',
    },
    STARTER: {
        id: 'plan.name.starter',
        text: 'Starter',
        description: 'Display name for the Starter plan tier',
    },
    GROWTH: {
        id: 'plan.name.growth',
        text: 'Growth',
        description: 'Display name for the Growth plan tier',
    },
    SCALE: {
        id: 'plan.name.scale',
        text: 'Scale',
        description: 'Display name for the Scale plan tier',
    },
});

/** Translate a plan key to its localized display name */
export function translatePlanName(key: string | undefined, t: (msg: string) => string): string {
    const map: Record<string, string> = {
        trial: t(PlanNameMessages.FREE),
        free: t(PlanNameMessages.FREE),
        starter: t(PlanNameMessages.STARTER),
        growth: t(PlanNameMessages.GROWTH),
        scale: t(PlanNameMessages.SCALE),
    };
    return map[key?.toLowerCase() || ''] || key || '';
}
